/** Ilustraciones remotas (especificación UI) */
export const PASSWORD_CHANGE_ILLUSTRATION_URL = "https://iili.io/qbA2ruf.png";
export const EMAIL_CHANGE_ILLUSTRATION_URL = "https://iili.io/qbAzEmP.webp";
export const PHONE_CHANGE_ILLUSTRATION_URL = "https://iili.io/qbAErrB.png";
export const ACCOUNT_BANK_ILLUSTRATION_URL = "https://iili.io/BFEivjI.png";
export const HELP_ILLUSTRATION_URL = "https://iili.io/qbRsBje.png";
